var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 617.36 867.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.59,202.44c-19.6,0-35.58-5.94-47.95-17.82-12.37-11.88-18.55-26.64-18.55-44.27s6.18-33.31,18.55-44.82c12.37-11.51,28.35-17.27,47.95-17.27s35.58,5.76,47.95,17.27c12.37,11.52,18.55,26.45,18.55,44.82s-6.19,33.01-18.55,44.64c-12.37,11.64-28.35,17.45-47.95,17.45Zm55.11,437.22H53.64V254.25h112.06v385.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M606.84,639.67h-112.06v-214.94c0-31.1-5.57-54.43-16.72-69.99-11.15-15.55-27.87-23.33-50.15-23.33s-39.44,8.33-53.64,24.98c-14.21,16.66-21.31,37.84-21.31,63.56v219.71h-112.43V254.25h112.43v61.36h1.47c14.2-23.76,31.65-41.52,52.36-53.27,20.7-11.76,44.64-17.64,71.83-17.64,42.62,0,74.64,13.29,96.08,39.86,21.43,26.58,32.15,66.2,32.15,118.86v236.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin2);
export default __webpack_public_path__ + "static/media/Linkedin2.b6084386b7b0f03fe01916b0a6cad8e9.svg";
export { ForwardRef as ReactComponent };